import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import bacsol from '../../assets/images/bacsol.png'
import fertipeixe from '../../assets/images/fertipeixe.jpg'
import vulcano from '../../assets/images/vulcano.jpg'
import LinhaDalneem from '../../assets/images/LinhaDalneem.jpg'
import bacvitta from '../../assets/images/bacvitta.jpg'
import homeopatia from '../../assets/images/homeopatia.jpg'
import linhaprotetores from '../../assets/images/linhaprotetores.jpg'
import packseed from '../../assets/images/packseed.jpg'
import linhamax from '../../assets/images/linhamax.jpg'

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Nossos produtos',
    paragraph: 'Selecionamos do nosso vasto catálogo, alguns dos nossos produtos. '
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <a name='nossosprodutos'></a>
          <SectionHeader  data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={bacsol}
                      alt="Features tile icon 01"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Bacsol
                    </h4>
                  <p className="m-0 text-sm">
                    Atua biologicamente na supressão de patógenos protegendo o sistema radicular e na liberação de nutrientes retidos no solo, conferindo economia, melhor produtividade e saúde para as plantas .
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={linhaprotetores}
                      alt="Features tile icon 02"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Linha de protetores
                    </h4>
                  <p className="m-0 text-sm">
                    Os indutores de resistência sistêmica, ativam as rotas metabólicas de defesa da cultura aplicada, por meio do mecanismo de ação do fósfito, junto com a nutrição necessária para cada estágio da cultura.                    
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={vulcano}
                      alt="Features tile icon 03"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Vulcano
                    </h4>
                  <p className="m-0 text-sm">
                    Remineralizador de solos “pó de rocha” rico em nutrientes como; cálcio, magnésio, potássio e silício, pode ser utilizado em qualquer cultura e não apresenta qualquer elemento que seja prejudicial ao solo, planta ou homem, sendo um produto altamente sustentável. Sua grande vantagem em relação a fontes de nutrientes solúveis é que não a perdas por lixiviação.
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={LinhaDalneem}
                      alt="Features tile icon 04"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Linha Dalneem
                    </h4>
                  <p className="m-0 text-sm">
                    A Torta de Neem é um fertilizante natural, resultante da extração do óleo dos frutos no Neem. Sua aplicação é via solo na forma de pó ou em solução via fertirrigação. Seus benefícios são inúmeros: Ação inseticida: afasta e inibe o crescimento de insetos prejudicais as plantas.
                    FITONEEM interrompe a reprodução dos insetos e esteriliza os órgãos reprodutores. Reduz a capacidade de crescimento dos insetos, agindo na regulação do crescimento: A atividade de ecdise é suprimida e a larva não consegue pupar, permanecendo na fase larval e, finalmente, morre.
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={bacvitta}
                      alt="Features tile icon 05"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Probióticos, Bacvitta, Vt suínos e Vt aves
                    </h4>
                  <p className="m-0 text-sm">
                    Linha de probióticos a base de fosfato bicalcico, enxofre, cobalto + bactéria e leveduras que promovem o aumento da taxa de conversão animal e sanidade é bem estar.
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={homeopatia}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    homeopatia
                  </h4>
                  <p className="m-0 text-sm">
                    Focados no equilíbrio de ecossistemas, de forma que possa ser reduzido o uso de produtos tóxicos e agressivos para as plantas, “remédios homeopáticos” podem ser aplicados na agricultura orgânica
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={fertipeixe}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    fertipeixe
                  </h4>
                  <p className="m-0 text-sm">
                    Fonte de nutrientes (carbono, óleo de pescado e aminoácidos) poderosos no processo de construção e manutenção do perfeito equilíbrio nutricional do solo. Promove o máximo aproveitamento das raízes, melhorando a eficiência da adubação e supressão de microorganismos maléficos as plantas e ao solo (Fusarium e Nematóides).                  
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={packseed}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Pack Seed
                  </h4>
                  <p className="m-0 text-sm">
                    Complexo nutricional completo para tratamento de sementes, rico em aminoácidos e minerais essenciais para o bom desenvolvimento inicial de plantas conferindo resistência sistemática a patógenos e favorecendo a produção acentuada de raizes.                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      className="bacsol"
                      src={linhamax}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Linha de Adjuvantes Max
                  </h4>
                  <p className="m-0 text-sm">
                    Linha de produtos desruptivos com mais de 22 benefícios comprovados na melhoria da sua aplicação. Compatíveis com aplicações de complexos biológicos.                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;